import Tooltip from './tooltip.js';

export default Tooltip;